import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const track = (action: string, name: string, filter_value?: string) => {
  GoogleTagManagerHelper.event(
    'Click',
    action,
    'uefa calendar',
    { section_reference: 'uefa calendar', interaction: action, filter_value },
    name,
  );
};
